
export const Modal = () => {

	/**
	 *
	 * @param {object} attributes
	 * @return {void}
	 */
	function _create( attributes ) {
		const { id = '', className = '', size = 'regular', title = '', content = '', callback = null, modalClose = true } = attributes;
		const elementId = id || 'modal-' + crypto.randomUUID();

		let modal = document.getElementById( elementId );

		if( ! modal ) {
			modal = document.createElement('div');
			modal.id = elementId;

			modal.classList.add('modal');
			if ( className ) {
				modal.classList.add( className );
			}

			if ( modalClose ) {
				modal.addEventListener('click', ( e ) => {
					if ( e.target.classList.contains('modal') ) {
						_close( modal );
					}
				});
			}
		}

		const closeButton = ! modalClose ? '' : `<button class="modal-close">Close</button>`;
		modal.innerHTML = `
			<div class="modal-inner modal-fade modal-${size}">
				<div class="modal-header">
					<h2 class="modal-title">${title}</h2>
					${closeButton}
				</div>
				<div class="modal-body">${content}</div>
			</div>
		`;

		backdrop();
		document.body.appendChild( modal );

		if ( modalClose ) {
			const close = () => _close( modal );
			modal.querySelector('.modal-close').addEventListener('click', close);
		}

		if( callback ) {
			callback();
		}
	}

	/**
	 * Open the modal.
	 *
	 * @param {string} elementId
	 * @return {void}
	 */
	function _open( elementId = null, callback = null ) {
		if( ! elementId || ! document.getElementById( elementId ) ) {
			return
		}

		const modal = document.getElementById( elementId );

		if( callback ) {
			callback();
		}

		backdrop().classList.add('show');
		modal.classList.add('show');
	}

	/**
	 * Close the modal.
	 *
	 * @param {HTMLElement|string} modal
	 * @return {void}
	 */
	function _close( modal ) {
		if( typeof modal === 'string' ) {
			modal = document.getElementById( modal );
		}

		modal.classList.remove('show');
		backdrop().classList.remove('show');
	}

	/**
	 * Create the backdrop element.
	 *
	 * @return {HTMLElement}
	 */
	function backdrop() {
		let backdrop = document.getElementsByClassName('modal-backdrop')[0];
		if ( backdrop ) {
			return backdrop;
		}

		backdrop = document.createElement('div');
		backdrop.classList.add('modal-backdrop', 'modal-fade');
		document.body.appendChild( backdrop );

		return backdrop;
	}

	return {
		open: _open,
		create: _create,
		close: _close
	};
};